
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/video-blogs",
      function () {
        return require("private-next-pages/en/video-blogs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/video-blogs"])
      });
    }
  